import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "HomeAndConstructionBusiness"],
  "@id": "https://aaairrigationservice.com/#business",
  "name": "AAA IRRIGATION SERVICE, LLC",
  "alternateName": "AAA Irrigation Service",
  "description": "TCEQ licensed irrigation repair and sprinkler system services in Allen, Plano, Frisco, McKinney and North Texas. License LI0016993.",
  "url": "https://aaairrigationservice.com",
  "telephone": "+14697513567",
  "email": "info@aaairrigationservice.com",
  "foundingDate": "2005",
  "logo": "https://aaairrigationservice.com/header_new.webp",
  "image": "https://aaairrigationservice.com/sprinklers.webp",
  "priceRange": "$$",
  "currenciesAccepted": "USD",
  "paymentAccepted": "Cash, Credit Card, Check",
  "hasMap": "https://maps.google.com/?q=AAA+Irrigation+Service+Allen+TX",
  "areaServed": [
    { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Richardson", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Murphy", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Wylie", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Lucas", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Fairview", "containedInPlace": { "@type": "State", "name": "Texas" } }
  ],
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Allen",
    "addressRegion": "TX",
    "postalCode": "75002",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "33.1032",
    "longitude": "-96.6706"
  },
  "openingHoursSpecification": [
    { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "07:00", "closes": "18:00" },
    { "@type": "OpeningHoursSpecification", "dayOfWeek": "Saturday", "opens": "08:00", "closes": "16:00" }
  ],
  "sameAs": [
    "https://www.google.com/maps/place/AAA+Irrigation+Service",
    "https://www.facebook.com/aaairrigationservice"
  ],
  "hasCredential": {
    "@type": "EducationalOccupationalCredential",
    "credentialCategory": "license",
    "name": "TCEQ Irrigation License LI0016993",
    "recognizedBy": { "@type": "Organization", "name": "Texas Commission on Environmental Quality" }
  },
  "serviceType": [
    "Sprinkler Repair", "Irrigation Repair", "Sprinkler Winterization & Freeze Protection",
    "Backflow Preventer Installation", "Valve Repair", "Sprinkler Head Repair",
    "Controller Repair", "Leak Detection", "Pressure Testing", "Commercial Irrigation",
    "HOA Irrigation", "Emergency Sprinkler Repair"
  ]
};

const SERVICE_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Sprinkler Repair",
    "provider": { "@id": "https://aaairrigationservice.com/#business" },
    "areaServed": [
      { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } }
    ],
    "description": "Expert sprinkler system repair including heads, valves, pipes, controllers, and leak detection. TCEQ Licensed LI0016993. Emergency service available.",
    "url": "https://aaairrigationservice.com/services/sprinkler-repair",
    "offers": { "@type": "Offer", "priceSpecification": { "@type": "PriceSpecification", "priceCurrency": "USD" } }
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Sprinkler Winterization & Freeze Protection",
    "provider": { "@id": "https://aaairrigationservice.com/#business" },
    "areaServed": [
      { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } }
    ],
    "description": "Seasonal sprinkler winterization, backflow preventer freeze protection, main valve shutoff, and rain/freeze sensor checks across Allen, Plano, Frisco, and North Texas.",
    "url": "https://aaairrigationservice.com/services/sprinkler-winterization"
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Backflow Preventer Installation",
    "provider": { "@id": "https://aaairrigationservice.com/#business" },
    "areaServed": [
      { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } }
    ],
    "description": "Backflow preventer installation and testing coordination for residential and commercial irrigation systems. Collin County compliant.",
    "url": "https://aaairrigationservice.com/services/backflow-preventer-installation"
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Commercial Irrigation Maintenance",
    "provider": { "@id": "https://aaairrigationservice.com/#business" },
    "areaServed": [
      { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } }
    ],
    "description": "Comprehensive irrigation maintenance programs for commercial properties, HOAs, and office parks. Monthly and quarterly service plans available.",
    "url": "https://aaairrigationservice.com/services/commercial-irrigation"
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Emergency Sprinkler Repair",
    "provider": { "@id": "https://aaairrigationservice.com/#business" },
    "areaServed": [
      { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } }
    ],
    "description": "After-hours emergency irrigation repair for major leaks, broken main lines, and system failures. Priority response to prevent water damage.",
    "url": "https://aaairrigationservice.com/services/emergency-repair"
  }
];

// Build a BreadcrumbList schema from the current pathname.
const buildBreadcrumbs = (pathname) => {
  const base = 'https://aaairrigationservice.com';
  if (!pathname || pathname === '/') return null;
  const segments = pathname.split('/').filter(Boolean);
  const items = [
    { "@type": "ListItem", position: 1, name: "Home", item: `${base}/` }
  ];
  const labelMap = {
    services: 'Services',
    'sprinkler-repair': 'Sprinkler Repair',
    'sprinkler-leak-repair': 'Sprinkler Leak Repair',
    'backflow-testing': 'Backflow Preventer Installation',
    'backflow-preventer-installation': 'Backflow Preventer Installation',
    'sprinkler-winterization': 'Sprinkler Winterization & Freeze Protection',
    'valve-repair': 'Valve Repair',
    'sprinkler-head-repair': 'Sprinkler Head Repair',
    'controller-repair': 'Controller Repair',
    'commercial-irrigation': 'Commercial Irrigation',
    'hoa-irrigation': 'HOA Irrigation',
    'emergency-repair': 'Emergency Sprinkler Repair',
    'pressure-testing': 'Pressure Testing',
    commercial: 'Commercial',
    contact: 'Contact',
    schedule: 'Schedule Service',
    locations: 'Service Areas',
    allen: 'Allen, TX',
    plano: 'Plano, TX',
    mckinney: 'McKinney, TX',
    frisco: 'Frisco, TX',
    richardson: 'Richardson, TX',
    wylie: 'Wylie, TX',
    murphy: 'Murphy, TX',
    lucas: 'Lucas, TX',
    fairview: 'Fairview, TX',
    privacy: 'Privacy Policy',
    terms: 'Terms & Conditions'
  };
  segments.forEach((seg, idx) => {
    const path = '/' + segments.slice(0, idx + 1).join('/');
    items.push({
      "@type": "ListItem",
      position: idx + 2,
      name: labelMap[seg] || seg.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
      item: `${base}${path}`
    });
  });
  return { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: items };
};

/**
 * SEO component — sets document title, meta description, keywords,
 * canonical URL, Open Graph tags, and LocalBusiness schema for each page.
 *
 * Optional props:
 *   ogImage      — override og:image for share previews (defaults to sprinklers.webp)
 *   extraSchema  — array (or single object) of additional JSON-LD schemas to inject
 *                   (Service, FAQPage, Review, etc.) keyed by route.
 */
export const SEO = ({ title, description, keywords, canonical, ogImage, extraSchema }) => {
  const location = useLocation();
  const baseUrl = 'https://aaairrigationservice.com';
  const canonicalUrl = canonical || `${baseUrl}${location.pathname}`;
  const shareImage = ogImage || 'https://aaairrigationservice.com/sprinklers.webp';

  useEffect(() => {
    document.title = title;

    const setMeta = (attr, attrValue, content) => {
      let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', description);
    if (keywords) setMeta('name', 'keywords', keywords);
    setMeta('name', 'robots', 'index, follow, max-image-preview:large, max-snippet:-1');

    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'AAA IRRIGATION SERVICE, LLC');
    setMeta('property', 'og:locale', 'en_US');
    setMeta('property', 'og:image', shareImage);

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', shareImage);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);

    // LocalBusiness schema — inject once, update @id per page
    let schema = document.getElementById('lb-schema');
    if (!schema) {
      schema = document.createElement('script');
      schema.id = 'lb-schema';
      schema.type = 'application/ld+json';
      document.head.appendChild(schema);
    }
    schema.textContent = JSON.stringify({ ...LOCAL_BUSINESS_SCHEMA, "@id": canonicalUrl + "#business" });

    // Service schema — inject once on homepage, remove on non-homepage routes
    if (location.pathname === '/') {
      let svcSchema = document.getElementById('svc-schema');
      if (!svcSchema) {
        svcSchema = document.createElement('script');
        svcSchema.id = 'svc-schema';
        svcSchema.type = 'application/ld+json';
        document.head.appendChild(svcSchema);
      }
      svcSchema.textContent = JSON.stringify(SERVICE_SCHEMA);
    } else {
      const existingSvc = document.getElementById('svc-schema');
      if (existingSvc) existingSvc.remove();
    }

    // BreadcrumbList — inject on non-home pages so Google can show breadcrumbs in SERP
    const existingCrumb = document.getElementById('crumb-schema');
    const crumb = buildBreadcrumbs(location.pathname);
    if (crumb) {
      let el = existingCrumb;
      if (!el) {
        el = document.createElement('script');
        el.id = 'crumb-schema';
        el.type = 'application/ld+json';
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(crumb);
    } else if (existingCrumb) {
      existingCrumb.remove();
    }

    // Extra route-specific JSON-LD (Service, FAQPage, Review, etc.)
    const existingExtra = document.getElementById('extra-schema');
    if (extraSchema) {
      const payload = Array.isArray(extraSchema) ? extraSchema : [extraSchema];
      let el = existingExtra;
      if (!el) {
        el = document.createElement('script');
        el.id = 'extra-schema';
        el.type = 'application/ld+json';
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(payload.length === 1 ? payload[0] : payload);
    } else if (existingExtra && location.pathname !== '/') {
      existingExtra.remove();
    }

  }, [title, description, keywords, canonicalUrl, shareImage, extraSchema, location.pathname]);

  return null;
};
